module.exports = __webpack_public_path__ + "media/floating-widget-preview.1fa2920b.mp4";